import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/homeview/stars_sunset.png';
import _imports_1 from '@/assets/homeview/stars_sunset.webm';
import _imports_2 from '@/assets/homeview/sky_cloud_sunset.png';
import _imports_3 from '@/assets/homeview/sky_cloud_sunset.webm';
import _imports_4 from '@/assets/homeview/valley/valley_sunset.png';
import _imports_5 from '@/assets/homeview/sun_flare.webm';
import _imports_6 from '@/assets/homeview/valley/waterfall_sunset.webm';
import _imports_7 from '@/assets/homeview/valley/clouds_sunset.png';
import _imports_8 from '@/assets/homeview/valley/clouds_sunset.webm';
import _imports_9 from '@/assets/homeview/island/tree_sunset.png';
import _imports_10 from '@/assets/homeview/island/tree_sunset.webm';
import _imports_11 from '@/assets/homeview/island/sakura_petals.webm';
import _imports_12 from '@/assets/homeview/island/island_sunset.png';
import _imports_13 from '@/assets/homeview/island/island_sunset.webm';
import _imports_14 from '@/assets/homeview/island/clouds_sunset.png';
import _imports_15 from '@/assets/homeview/island/clouds_sunset.webm';
import _imports_16 from '@/assets/homeview/cliff/cliff_sunset.png';
import _imports_17 from '@/assets/homeview/cliff/sakura_sunset.png';
import _imports_18 from '@/assets/homeview/cliff/sakura_sunset.webm';
const _hoisted_1 = {
  class: "sunset-layers"
};
const _hoisted_2 = {
  class: "background-layer"
};
const _hoisted_3 = {
  class: "sky-section"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_1,
  type: "video/webm"
}, null, -1);
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_3,
  type: "video/webm"
}, null, -1);
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "valley-section luxy-el",
  "data-speed-y": "-3"
};
const _hoisted_9 = {
  class: "valley-wrapper",
  "data-scroll": "",
  "data-scroll-speed": "0.5"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_5,
  type: "video/webm"
}, null, -1);
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_6,
  type: "video/webm"
}, null, -1);
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_8,
  type: "video/webm"
}, null, -1);
const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = {
  class: "foreground-layer"
};
const _hoisted_17 = {
  class: "tree-island-section luxy-el",
  "data-speed-y": "8"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_10,
  type: "video/webm"
}, null, -1);
const _hoisted_19 = [_hoisted_18];
const _hoisted_20 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_11,
  type: "video/webm"
}, null, -1);
const _hoisted_21 = [_hoisted_20];
const _hoisted_22 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_13,
  type: "video/webm"
}, null, -1);
const _hoisted_23 = [_hoisted_22];
const _hoisted_24 = {
  class: "island-clouds-section luxy-el",
  "data-speed-y": "8"
};
const _hoisted_25 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_10,
  type: "video/webm"
}, null, -1);
const _hoisted_26 = [_hoisted_25];
const _hoisted_27 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_15,
  type: "video/webm"
}, null, -1);
const _hoisted_28 = [_hoisted_27];
const _hoisted_29 = {
  class: "cliff-section"
};
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  class: "cliff luxy-el",
  src: _imports_16,
  "data-speed-y": "-6",
  "data-offset": "0"
}, null, -1);
const _hoisted_31 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_18,
  type: "video/webm"
}, null, -1);
const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  id: "stop-cliff"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("section", _hoisted_3, [_createElementVNode("video", {
    class: "stars",
    muted: "",
    preload: "metadata",
    loop: "loop",
    onLoadedmetadata: _cache[0] || (_cache[0] = event => _ctx.loadVideo(event)),
    poster: _imports_0,
    onLoadeddata: _cache[1] || (_cache[1] = () => _ctx.decreaseLoadingImageAssets())
  }, _hoisted_5, 32), _createElementVNode("video", {
    class: "sky-cloud",
    muted: "",
    preload: "metadata",
    loop: "loop",
    onLoadedmetadata: _cache[2] || (_cache[2] = event => _ctx.loadVideo(event)),
    poster: _imports_2,
    onLoadeddata: _cache[3] || (_cache[3] = () => _ctx.decreaseLoadingImageAssets())
  }, _hoisted_7, 32)]), _createElementVNode("section", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    class: "valley",
    src: _imports_4,
    onLoadeddata: _cache[4] || (_cache[4] = () => _ctx.decreaseLoadingImageAssets())
  }, null, 32), _createElementVNode("video", {
    class: "sun-flare hidden-md-and-down",
    muted: "",
    preload: "metadata",
    loop: "loop",
    onLoadedmetadata: _cache[5] || (_cache[5] = event => _ctx.loadVideo(event))
  }, _hoisted_11, 32), _createElementVNode("video", {
    class: "waterfall hidden-md-and-down",
    muted: "",
    preload: "metadata",
    loop: "loop",
    onLoadedmetadata: _cache[6] || (_cache[6] = event => _ctx.loadVideo(event))
  }, _hoisted_13, 32), _createElementVNode("video", {
    class: "clouds",
    muted: "",
    preload: "metadata",
    loop: "loop",
    onLoadedmetadata: _cache[7] || (_cache[7] = event => _ctx.loadVideo(event)),
    poster: _imports_7,
    onLoadeddata: _cache[8] || (_cache[8] = () => _ctx.decreaseLoadingImageAssets())
  }, _hoisted_15, 32)])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("section", _hoisted_17, [_createElementVNode("video", {
    class: "tree",
    muted: "",
    preload: "metadata",
    loop: "loop",
    onLoadedmetadata: _cache[9] || (_cache[9] = event => _ctx.loadVideo(event)),
    poster: _imports_9,
    onLoadeddata: _cache[10] || (_cache[10] = () => _ctx.decreaseLoadingImageAssets())
  }, _hoisted_19, 32), _createElementVNode("video", {
    class: "sakura_petals hidden-md-and-down",
    muted: "",
    preload: "metadata",
    loop: "loop",
    onLoadedmetadata: _cache[11] || (_cache[11] = event => _ctx.loadVideo(event))
  }, _hoisted_21, 32), _createElementVNode("video", {
    class: "island",
    muted: "",
    preload: "metadata",
    loop: "loop",
    onLoadedmetadata: _cache[12] || (_cache[12] = event => _ctx.loadVideo(event)),
    poster: _imports_12,
    onLoadeddata: _cache[13] || (_cache[13] = () => _ctx.decreaseLoadingImageAssets())
  }, _hoisted_23, 32)]), _createElementVNode("section", _hoisted_24, [_createElementVNode("video", {
    class: "tree",
    muted: "",
    preload: "metadata",
    loop: "loop",
    onLoadedmetadata: _cache[14] || (_cache[14] = event => _ctx.loadVideo(event)),
    poster: _imports_9,
    onLoadeddata: _cache[15] || (_cache[15] = () => _ctx.decreaseLoadingImageAssets())
  }, _hoisted_26, 32), _createElementVNode("video", {
    class: "clouds",
    muted: "",
    preload: "metadata",
    loop: "loop",
    onLoadedmetadata: _cache[16] || (_cache[16] = event => _ctx.loadVideo(event)),
    poster: _imports_14,
    onLoadeddata: _cache[17] || (_cache[17] = () => _ctx.decreaseLoadingImageAssets())
  }, _hoisted_28, 32)]), _createElementVNode("section", _hoisted_29, [_hoisted_30, _createElementVNode("video", {
    class: "sakura luxy-el",
    muted: "",
    preload: "metadata",
    loop: "loop",
    "data-speed-y": "-12",
    "data-offset": "175",
    onLoadedmetadata: _cache[18] || (_cache[18] = event => _ctx.loadVideo(event)),
    poster: _imports_17,
    onLoadeddata: _cache[19] || (_cache[19] = () => _ctx.decreaseLoadingImageAssets())
  }, _hoisted_32, 32), _hoisted_33])])]);
}